import CatalogOperationService from "fs-pb-vue2/services/operations/CatalogOperationService";
import { inject, injectable } from "inversify";
import { OperationInitTypes } from "fs-pb-vue2/models/enums/operationInitTypes";
import { CatalogOperationModel } from "fs-pb-vue2/models/operations/catalogOperationModel";
import { OperationRequestData } from "fs-pb-vue2/data/operationRequestData";
import { TemplatesApi } from "fs-pb-vue2/services/api/TemplatesApi";
import { OperationsApi } from "fs-pb-vue2/services/api/OperationsApi";
import { DeclarationPropertyValueData } from "fs-pb-vue2/data/declarationPropertyValueData";
import { DeclarationPropertiesTypes } from "fs-pb-vue2/data/enums/declarationPropertiesTypes";
import currencyFilter from "fs-pb-vue2/filters/currency.filter";
import router from "@/router";

/**Сервис проведения операций */
@injectable()
export default class SnbCatalogOperationService extends CatalogOperationService {

    /**
   * Инициализация операции
   * @param initData Данные для инициализации
   * */
  public async init(
    id: number,
    type: OperationInitTypes,
    addInitData: any = {}
  ): Promise<CatalogOperationModel> {
    if (!Object.keys(this.configStore.phoneFormatDir.FormatDict).length) {
      if (!this.configStore.apiData?.PhoneFormatDirFile) {
        await this.configStore.fetchApiState();
      }
      await this.configStore.fetchPhoneFormatDir();
    }
    let template: OperationRequestData | null = null;
    let catalogId = id;
    let caption: string = "";
    if (type != OperationInitTypes.New) {
      if (type == OperationInitTypes.ByTemplate) {
        template = await TemplatesApi.getTemplateAsync(id);
        caption = template?.templateName as string;
      } else if (type == OperationInitTypes.Repeat) {
        template = await OperationsApi.getRepeatOperationAsync(id);
        caption = template?.caption as string;
      }
      catalogId = parseInt(template?.respondentCode as string);
    }

    try {
      const declaration = await OperationsApi.getDeclarationAsync(catalogId, this.configStore.apiData.OperationCodeOfToOtherContractByCard, this.configStore.apiData.OperationCodeOfToExt);
      const respondent = await OperationsApi.getRespondentAsync(catalogId);

      declaration.Caption = caption ? caption : respondent.Caption;

      //declaration.Description = respondent.Description;
      let model: CatalogOperationModel = new CatalogOperationModel(
        declaration,
        this.contractsStore.contracts,
        template,
        addInitData,
        this.configStore
      );
      model.Description = declaration.Description;
      model.Picture = respondent.Picture;

      if (type == OperationInitTypes.New) {
        //Вызываем assign.
        for (let i = 0; i < model.Properties.length; i++) {
          const prop = model.Properties[i];
          //(id === respondent.Id && respondent.Config == "Me2MePull" && prop.Declaration.Name == 'contract') (id.toString() === this.configStore.apiData.OperationCodeOfMe2MeOperation && prop.Declaration.Name == 'contract')
          if (id.toString() === this.configStore.apiData.OperationCodeOfMe2MeOperation && prop.Declaration.Name == 'contract') {
            const ac: any = this.contractsStore.contracts.getContractByRefId(this.personStore.personInfo.Data.DefaultInAccount);
            prop.Value = new DeclarationPropertyValueData(
              this.personStore.personInfo.Data.DefaultInAccount,
              `${ac?.Data?.Alias.trim() === ""
                ? ac?.Data?.MainAccount.substring(0, 5) +
                "*" +
                ac?.Data?.MainAccount.substring(16, 4)
                : ac?.Data?.Alias
              } - ${ac?.Data?.ContractType == 5
                ? ac?.DepositSum
                : ac?.DisposableLimit
              } ${currencyFilter(ac?.Data?.CurrencyCharCode)}`,
              ''
            )
            prop.Declaration.Default = prop.Value;
            prop.Values.push(prop.Value);
          }
          if (Object.keys(addInitData).includes(prop.Declaration.Name)
            && addInitData[prop.Declaration.Name] !== prop.Value
            && prop.Declaration.Default
          ) {
            prop.setProperty(prop.Declaration.Default);
          }
          if (!Object.keys(addInitData).includes(prop.Declaration.Name) && prop.Declaration.Type === DeclarationPropertiesTypes.UserAccount && prop.Declaration.Name == 'contract') {
            const defaulAccOut: string = this.personStore.personInfo.Data.DefaultOutAccount;
            if (defaulAccOut && prop.Values.find((val: DeclarationPropertyValueData) => val.Key === defaulAccOut))
              prop.Declaration.Default = defaulAccOut;
            else
              prop.Declaration.Default = prop.Values[0].Key;
            if (prop.Declaration.Default)
              prop.setProperty(prop.Declaration.Default);
          }
          // Загрузка значения по умолчанию.
          if (
            prop.Declaration.Default &&
            prop.Declaration.Default.trim() !== ""
            && prop.Declaration.Assign
          ) {
            model = await this.assignRequestSnb(prop.Declaration.Name, model);
          }
          
        }
      } else {
        await model.setOperationFromRequest(template, true, true);
      }

      return model;
    } catch (e) {
      console.log(e);
      router.go(-1);
      await this.errorService.errorHandler(e, false, true, "");
    }
  }

  private async assignRequestSnb(name: string, model: CatalogOperationModel): Promise<CatalogOperationModel> {
    let ord: OperationRequestData = await model.createOperationRequest();
    ord.assignProperty = name;
    ord = await OperationsApi.assignOperationSendAsync(ord);

    if (ord.message)
      await this.alertService.info(ord.message, false);

    await model.setOperationFromRequest(ord, true);
    model.propertyErrorsComes = Object.keys(ord.PropertyErrors).length > 0;
    return model;
  }
}
